import { create } from 'zustand'
import { WAVE_PLANS } from '@/components/WavePlanning/plans'

// UI selection only. Like planning drafts, it survives navigation, not reloads.
export const useWaveRollupSelectionStore = create<{
  selectedPlanIds: string[]
  setSelectedPlanIds: (ids: string[]) => void
  selectPlans: (ids: string[], checked: boolean) => void
}>((set, get) => ({
  selectedPlanIds: [],
  setSelectedPlanIds: ids =>
    set({
      selectedPlanIds: WAVE_PLANS.filter(plan => ids.includes(plan.id)).map(
        plan => plan.id
      ),
    }),
  selectPlans: (ids, checked) => {
    const selected = new Set(get().selectedPlanIds)
    ids.forEach(id => (checked ? selected.add(id) : selected.delete(id)))
    get().setSelectedPlanIds([...selected])
  },
}))
